var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-version"},[_vm._v(" Version "+_vm._s(_vm.pjson.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }